








import { defineComponent, PropType } from '@vue/composition-api';
import { HighlightsRichTextMetadata } from '../../model';

export default defineComponent({
	props: {
		meta: {
			type: Object as PropType<HighlightsRichTextMetadata>,
			required: true,
		},
	},
});
